import React, { useRef, useEffect } from "react";
import { StopCircle, Mic } from "lucide-react";

const SimulationTranscription = ({ 
  isRecording, 
  hasStartedRecording,
  transcription, 
  persistentLines,
  uploadStatus,
  onStartRecording,
  onStopRecording
}) => {
  const transcriptionEndRef = useRef(null);

  useEffect(() => {
    if (transcriptionEndRef.current) {
      const container = transcriptionEndRef.current.closest('.transcription-content');
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }
  }, [persistentLines, transcription]);

  return (
    <div className="bg-white p-4 shadow-md shadow-blue-900/5 max-w-full relative rounded-xl">
      <h3 className="font-semibold my-2">Your Response</h3>
      <div className="bg-gray-50 border border-gray-200 rounded-md p-3 h-[200px] overflow-y-auto flex flex-col justify-between">
        <div className="flex-grow overflow-y-auto transcription-content">
          {persistentLines.map((line, index) => (
            <p
              key={`persistent-${index}-transcription`}
              className="my-1 leading-normal text-sm text-gray-700"
            >
              {line}
            </p>
          ))}

          {transcription && (
            <p
              key="interim-transcription"
              className="my-1 leading-normal text-sm text-gray-700"
            >
              {transcription}
            </p>
          )}

          <div ref={transcriptionEndRef} />
        </div>

        <div className="mt-3 flex justify-end">
          <button
            className={`flex items-center justify-center ${
              isRecording
                ? "bg-red-100 text-red-700 hover:bg-red-200"
                : "bg-blue-100 text-primaryDark hover:bg-blue-200"
            } border-none rounded-md py-2 px-3 text-sm font-medium cursor-pointer transition-all duration-200`}
            onClick={isRecording ? onStopRecording : onStartRecording}
          >
            {isRecording ? (
              <>
                <StopCircle size={16} className="mr-1.5" />
                Stop Recording
              </>
            ) : (
              <>
                <Mic size={16} className="mr-1.5" />
                Record Response
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimulationTranscription;